module.exports = __webpack_public_path__ + "static/media/p3.a16a08f8.png";